'use client';

import { useState, useEffect } from 'react';



const Footer = () => {
  const [currentYear, setCurrentYear] = useState<number | null>(null);

  useEffect(() => {
    setCurrentYear(new Date()?.getFullYear());
  }, []);

  const footerLinks = {
    product: [
      { label: 'Pricing Calculator', href: '/creator-stage-selection' },
      { label: 'Services', href: '#services' },
      { label: 'Portfolio', href: '#portfolio' },
      { label: 'Testimonials', href: '#testimonials' },
    ],
    company: [
      { label: 'About Us', href: '#about' },
      { label: 'Careers', href: '#careers' },
      { label: 'Blog', href: '#blog' },
      { label: 'Contact', href: '#contact' },
    ],
    support: [
      { label: 'Help Center', href: '#help' },
      { label: 'FAQ', href: '#faq' },
      { label: 'Terms of Service', href: '#terms' },
      { label: 'Privacy Policy', href: '#privacy' },
    ],
  };

  const socialLinks = [
    { icon: 'ChatBubbleLeftIcon', label: 'Twitter', href: '#twitter' },
    { icon: 'VideoCameraIcon', label: 'YouTube', href: '#youtube' },
    { icon: 'BriefcaseIcon', label: 'LinkedIn', href: '#linkedin' },
    { icon: 'CameraIcon', label: 'Instagram', href: '#instagram' },
  ];

  return (
    <footer className="bg-card border-t border-border">
      <div className="container mx-auto px-4 py-12 md:py-16">
      </div>
    </footer>
  );
};

export default Footer;